import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CheckCircle2, Circle } from "lucide-react";

interface ChecklistItem {
  text: string;
  checked?: boolean;
}

interface ChecklistProps {
  title?: string;
  items: (ChecklistItem | string)[];
  printable?: boolean;
}

export const Checklist = ({ title, items, printable = false }: ChecklistProps) => {
  // Normalize items to ChecklistItem format
  const normalizedItems = items.map(item => 
    typeof item === 'string' ? { text: item } : item
  );
  
  const listContent = (
    <ul className="space-y-3">
      {normalizedItems.map((item, index) => (
        <li key={index} className="flex items-start gap-3">
          {item.checked !== undefined ? (
            item.checked ? (
              <CheckCircle2 className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" />
            ) : (
              <Circle className="h-5 w-5 text-muted-foreground flex-shrink-0 mt-0.5" />
            )
          ) : (
            <Circle className="h-5 w-5 text-muted-foreground flex-shrink-0 mt-0.5" />
          )}
          <span>{item.text}</span>
        </li>
      ))}
    </ul>
  );
  
  // If no title, just render the list (for use inside existing Cards)
  if (!title) {
    return listContent;
  }
  
  return (
    <Card className={printable ? "print:border-2 print:border-foreground" : ""}>
      <CardHeader>
        <CardTitle className="text-xl flex items-center gap-2">
          <CheckCircle2 className="h-5 w-5 text-primary" />
          {title}
        </CardTitle>
        {printable && (
          <p className="text-sm text-muted-foreground">Print this checklist for reference</p>
        )}
      </CardHeader>
      <CardContent>
        {listContent}
      </CardContent>
    </Card>
  );
};
